<mat-card>
  <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
    <strong class="noMarginHeader">Results ({{resultSize}})</strong>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <mat-form-field style="width:200px;">
      <input (keyup)="filterTable($event)" placeholder="Filter results" matInput />
    </mat-form-field>
    <br />
    <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
      <mat-row>Results ({{resultSize}})</mat-row>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Voucher Identifier</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <a (click)="editVoucher(result.voucherId)" title="Edit Voucher {{result.applicationIdentifier}}">{{result.applicationIdentifier}}</a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="applicationType">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Type</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.applicationType}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="applicationStatus">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.applicationStatus}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="contactAddress">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Contact Address</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.applicantAddress}} {{result.applicantCity}} {{result.applicantState}} {{result.applicantZip}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="applicantContactName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Contact Name</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.applicantContactName}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="voucherMaxValue">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Max Value</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.voucherMaxValue}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="redeemed">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Redeemed</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <span *ngIf="result.redeemed">Yes</span>
          <span *ngIf="!result.redeemed">No</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="exceedencesDetected">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Exceedences Detected</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <span *ngIf="result.exceedencesDetected">Yes</span>
          <span *ngIf="!result.exceedencesDetected">No</span>
        </mat-cell>
      </ng-container>
    </mat-table>
    <br />
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
  </div>
</mat-card>